const initialState = {
  restFilterData: [],
  restaurantList: [],
  restaurantDataList: [],
  isFetchingRestaurant: false,
  isAddingRestaurant: false,
  isEditingRestaurant: false,
};

const ResturantReducer = (state = initialState, action) => {
  switch (action.type) {

    case "REQUEST_RESTAURANT_GET_DATA":
      return { ...state, isFetchingRestaurant: true };
    case "SUCCESS_RESTAURANT_GET_DATA":
      return { ...state, restaurantDataList: action.payload.data, isFetchingRestaurant: false, };
    case "ERROR_RESTAURANT_GET_DATA":
      return { ...state, };


    case "REQUEST_ADD_RESTAURANT":
      return { ...state, isAddingRestaurant: true };
    case "SUCCESS_ADD_RESTAURANT":
      return { ...state, restaurantList: action.payload, isAddingRestaurant: false, };
    case "ERROR_ADD_RESTAURANT":
      return { ...state, isAddingRestaurant: false };


    default:
      return state;
  }
};
export default ResturantReducer;